'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainMenu = undefined;

var _templateObject = _taggedTemplateLiteral(['\n'], ['\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n'], ['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 1.143em;\n  font-weight: 400;\n\n  @media ', ' {\n    & ', ' {\n      display: inline-block;\n      margin: 0;\n      margin-right: 1em;\n    }\n  }\n'], ['\n  font-size: 1.143em;\n  font-weight: 400;\n\n  @media ', ' {\n    & ', ' {\n      display: inline-block;\n      margin: 0;\n      margin-right: 1em;\n    }\n  }\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _MobileMenu = require('./MobileMenu');

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */
/*:: import {LangSelect} from './LangSelect' */


var MenuItem = _styledComponents2.default.li(_templateObject);
MenuItem.displayName = 'MenuItem';

var Menu = _styledComponents2.default.ul(_templateObject2);
Menu.displayName = 'Menu';

/*::
type Props = {|
    className?: string,
    children: React.Node,
    languageSelector?: typeof LangSelect
|}
*/
var MainMenu /*: ComponentType<Props> */ = (0, _styledComponents2.default)(function (_ref) {
  var className = _ref.className,
      children = _ref.children,
      languageSelector = _ref.languageSelector,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'languageSelector']);

  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      'nav',
      Object.assign({ className: className }, props),
      React.createElement(
        Menu,
        null,
        React.Children.map(children, function (child) {
          return React.createElement(
            MenuItem,
            null,
            child
          );
        })
      )
    ),
    languageSelector,
    React.createElement(
      _MobileMenu.MobileMenu,
      null,
      React.createElement(
        Menu,
        null,
        React.Children.map(children, function (child) {
          return React.createElement(
            MenuItem,
            null,
            child
          );
        })
      ),
      languageSelector
    )
  );
})(_templateObject3, _styles.styles.media.laptop, MenuItem);
exports.MainMenu = MainMenu;
MainMenu.displayName = 'MainMenu';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/MainMenu.js
// module id = 240
// module chunks = 0